import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import FuzzyText from './FuzzyText';

const NewServicesMobile = () => {
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const isRTL = i18n.language === 'ar';

    const services = [
        {
            key: 'dental_anxiety',
            title: t('new_services.services.dental_anxiety.title'),
            subtitle: t('new_services.services.dental_anxiety.subtitle'),
            img: '/new images/anxiety patient.png',
        },
        {
            key: 'aesthetic_dentistry',
            title: t('new_services.services.aesthetic_dentistry.title'),
            subtitle: t('new_services.services.aesthetic_dentistry.subtitle'),
            img: '/Assets/DENTISTRY.jpg',
        },
        {
            key: 'implantology',
            title: t('new_services.services.implantology.title'),
            subtitle: t('new_services.services.implantology.subtitle'),
            img: '/Assets/implantology.jpg',
        },
        {
            key: 'root_canal_therapy',
            title: t('new_services.services.root_canal_therapy.title'),
            subtitle: t('new_services.services.root_canal_therapy.subtitle'),
            img: '/new images/miko cleaned.png',
        },
        {
            key: 'dental_prosthetics',
            title: t('new_services.services.dental_prosthetics.title'),
            subtitle: t('new_services.services.dental_prosthetics.subtitle'),
            img: '/Assets/DENTAL PROSTHETICS.jpg',
        },
        {
            key: 'oral_surgery',
            title: t('new_services.services.oral_surgery.title'),
            subtitle: t('new_services.services.oral_surgery.subtitle'),
            img: '/new images/ORALCHIRURGIE.png',
        },
        {
            key: 'orthodontics',
            title: t('new_services.services.orthodontics.title'),
            subtitle: t('new_services.services.orthodontics.subtitle'),
            img: '/Assets/Orthodontics Invisalign.jpg',
        },
        {
            key: 'paediatric_dentistry',
            title: t('new_services.services.paediatric_dentistry.title'),
            subtitle: t('new_services.services.paediatric_dentistry.subtitle'),
            img: '/Assets/Paediatric Dentistry.jpg',
        },
        {
            key: 'professional_cleaning',
            title: t('new_services.services.professional_cleaning.title'),
            subtitle: t('new_services.services.professional_cleaning.subtitle'),
            img: '/new images/prophylaxe.png',
        },
        {
            key: 'bleaching',
            title: t('new_services.services.bleaching.title'),
            subtitle: t('new_services.services.bleaching.subtitle'),
            img: '/new images/bleaching cleaned 2 .png',
        },
        {
            key: 'periodontitis_therapy',
            title: t('new_services.services.periodontitis_therapy.title'),
            subtitle: t('new_services.services.periodontitis_therapy.subtitle'),
            img: '/Assets/Periodontitis Therapy.jpg',
        },
    ];

    return (
        <div className="bg-[#e8e2d4] py-16 px-4 font-sans" dir={isRTL ? 'rtl' : 'ltr'}>
            <div className="container mx-auto">
                <div className="mb-12">
                    <h1 className={`text-4xl font-bold text-[#422f40] uppercase tracking-tighter ${isRTL ? 'text-right' : 'text-left'}`}>
                        {t('new_services.title')}
                    </h1>
                </div>
                <div className="mb-12 max-w-5xl mx-auto">
                    <p className={`text-md text-gray-600 leading-relaxed ${isRTL ? 'text-right' : 'text-start'}`}>
                        {t('new_services.description')}
                    </p>
                </div>

                {services.map((service, index) => (
                    <Link 
                        key={service.key}
                        to={`/service-mobile/${service.key}`}
                        state={{ background: location }}
                        className={`flex items-start mb-12 no-underline hover:no-underline focus:no-underline ${isRTL ? 'flex-row-reverse' : ''}`}
                        style={{ textDecoration: 'none' }}
                    >
                        <div className={`w-1/3 ${isRTL ? 'pl-4 md:pl-6' : 'pr-4 md:pr-6'}`}>
                            <div className="aspect-[3/4]">
                                <img src={service.img} alt={service.title} className="w-full h-full object-cover" />
                            </div>
                        </div>
                        <div className="w-2/3">
                            <h2 className={`text-lg sm:text-xl md:text-2xl font-bold text-[#422f40] uppercase leading-tight tracking-tight break-words ${isRTL ? 'text-right' : 'text-left'}`}>{service.title}</h2>
                            <p className={`text-sm sm:text-base text-[#422f40] uppercase mt-2 tracking-wider leading-tight ${isRTL ? 'text-right' : 'text-left'}`}>{service.subtitle}</p>
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
};

export default NewServicesMobile; 